/*
 * View for the topics using category modal
 */

define(["marionette", "./template/topicsUsingCategoryModalTemplate.html"], function (
  Marionette,
  TopicsUsingCategoryModalTemplate,
) {
  var TopicsUsingCategoryModalView = {};

  TopicsUsingCategoryModalView.topicsUsingCategoryModalLayout = Marionette.Layout.extend({
    template: TopicsUsingCategoryModalTemplate,
    regions: {
      topicsUsingCategoryList: "#topicsUsingCategoryList",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
    hideError: function () {
      this.$el.find("#deleteCategoryError").hide();
    },
    showError: function () {
      this.$el
        .find("#deleteCategoryError")
        .attr("data-i18n", "admin.categories.category.deleteError")
        .i18n()
        .show();
    },
  });

  return TopicsUsingCategoryModalView;
});
